import { HomeIcon } from '@heroicons/react/20/solid';
import { Link } from 'react-router-dom';
import { BreadCrumbPage } from '@employ-engage/data';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface BreadCrumbsProps {
  homePath?: string;
  pages: BreadCrumbPage[];
  className?: string;
}

export function BreadCrumbs({
  homePath = '/',
  pages,
  className,
}: BreadCrumbsProps) {
  const { t } = useTranslation(['common']);
  return (
    <nav className={classNames('flex', className)} aria-label="Breadcrumb">
      <ol className="flex space-x-4 rounded-md bg-white px-6 shadow">
        <li className="flex">
          <div className="flex items-center">
            <Link to={homePath} className="text-gray-400 hover:text-gray-500">
              <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
              <span className="sr-only">{t('Home')}</span>
            </Link>
          </div>
        </li>
        {pages.map((page, index, pages) => (
          <li key={page.name} className="flex">
            <div className="flex items-center">
              <svg
                className="h-full w-6 flex-shrink-0 text-gray-200"
                viewBox="0 0 24 44"
                preserveAspectRatio="none"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
              </svg>
              {index === pages.length - 1 ? (
                <div
                  className="ml-4 text-sm font-medium text-gray-500"
                  aria-current="page"
                >
                  {page.name}
                </div>
              ) : (
                <Link
                  to={page.to}
                  className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                >
                  {page.name}
                </Link>
              )}
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}

export default BreadCrumbs;
